import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionComponent } from './accordion.component';
import { AccordionPanelComponent } from './accordion-panel/accordion-panel.component';
import { LunaCommonModule } from '../../common.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
    imports: [
        CommonModule,
        LunaCommonModule,
        BrowserAnimationsModule
    ],
    declarations: [
        
    ],
    exports: [
        AccordionComponent,
        AccordionPanelComponent
    ]
})
export class AccordionModule { }
